import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ApiEndpoints, reqGetNew, reqPostNew } from "../../../config/apiClient";
import Select from "react-select";
import { Button, Form } from "react-bootstrap";
import dayjs from "dayjs";
import { defineValueInInput, getValueFromInput } from "../../../components/funcForInput";
import LoadingModal from "../../../components/loadingModal";
import DataTable from "../../../components/dataTable/DataTable";
import { createColumnHelper } from "@tanstack/react-table";
import RondaRegistroModal from "./RondaRegistroModal";

export default function RondasRegistrosPage() {
    const [loading, setLoading] = useState<boolean>(false);
    const [dados, setDados] = useState<any[]>([]);
    const [dadosFormatados, setDadosFormatados] = useState<any[]>([]);

    const [rondaRegistro, setRondaRegistro] = useState<any>({});
    const [showModalRonda, setShowModalRonda] = useState<boolean>(false);

    const [rondasOptions, setRondasOptions] = useState<any[]>([]);
    const [rondasStatusOptions, setRondasStatusOptions] = useState<any[]>([]);
    const [qrcodesOptions, setQrcodesOptions] = useState<any[]>([]);
    const [colaboradoresOptions, setColaboradoresOptions] = useState<any[]>([]);

    const [rondasSelection, setRondasSelection] = useState<any[]>([]);
    const [rondasStatusSelection, setRondasStatusSelection] = useState<any[]>([]);
    const [qrcodesSelection, setQrcodesSelection] = useState<any[]>([]);
    const [colaboradoresSelection, setColaboradoresSelection] = useState<any[]>([]);

    useEffect(() => {
        document.title = "Rondas Registros | OB PORTUS";

        async function carregarFiltros() {
            setLoading(true);
            const data_atual = dayjs();
            const data_inicial = data_atual.subtract(7, "days").format("YYYY-MM-DD");
            defineValueInInput("data_inicial", data_inicial);
            const data_final = data_atual.format("YYYY-MM-DD");
            defineValueInInput("data_final", data_final);
            const response = await reqGetNew(ApiEndpoints.qrcodeRondaFiltros);
            if (response.status === 200) {
                const rondas: any[] = response.data["rondas"];
                setRondasOptions(
                    rondas.map((item: any) => ({
                        value: String(item.id_ronda),
                        label: String(item.descricao),
                    })),
                );
                const status: any[] = response.data["status"];
                setRondasStatusOptions(
                    status.map((item: any) => ({
                        value: String(item.id_status),
                        label: String(item.descricao),
                    })),
                );
                const qrcodes: any[] = response.data["qrcodes"];
                setQrcodesOptions(
                    qrcodes.map((item: any) => ({
                        value: String(item.id_qrcode),
                        label: String(item.descricao),
                    })),
                );
                const colaboradores: any[] = response.data["colaboradores"];
                setColaboradoresOptions(
                    colaboradores.map((item: any) => ({
                        value: String(item.id_colaborador),
                        label: String(`${item.matricula} - ${item.nome_completo}`),
                    })),
                );
                await carregarRondas();
            } else {
                setLoading(false);
                toast.error("Não foi possível carregar os filtros de ronda.", { containerId: 1, position: "top-center", theme: "dark" });
            }
        }
        void carregarFiltros();
        // eslint-disable-next-line
    }, []);

    async function carregarRondas() {
        setLoading(true);
        const dados = {
            data_inicial: getValueFromInput("data_inicial"),
            data_final: getValueFromInput("data_final"),
            ids_rondas: rondasSelection.map((reg) => (Number(reg.value))),
            ids_status: rondasStatusSelection.map((reg) => (Number(reg.value))),
            ids_qrcodes: qrcodesSelection.map((reg) => (Number(reg.value))),
            ids_colaboradores: colaboradoresSelection.map((reg) => (Number(reg.value))),
        };
        const api = await reqPostNew(ApiEndpoints.qrcodeRondaRegistros, dados);
        setLoading(false);

        if (api.status === 200) {
            setDados(api.data);
            const dadosFormatados = rondasDadosFormatar(api.data);
            setDadosFormatados(dadosFormatados);
        }
    }

    function rondasDadosFormatar(dados: any[]): iRondasRegistrosView[] {
        let rondas: iRondasRegistrosView[] = [];
        for (let ronda of dados) {
            const rondaRegistros:any[] = ronda["registros_pontos"]
            const regRondas = `${rondaRegistros.length} Registros`
            const rondaOcorrencias: any[] = ronda["registros_ocorrencias"]
            const regOcorrencias = `${rondaOcorrencias.length} Ocorrências`
            let rondaAux: iRondasRegistrosView = {
                id_ronda_registro: ronda.id_ronda_registro,
                data_inicio: ronda.data_inicio,
                data_fim: ronda.data_fim,
                matricula: ronda.colaborador.matricula,
                nome_completo: ronda.colaborador.nome_completo,
                ronda_nome: ronda.ronda.descricao,
                ronda_status: ronda.ronda_status.descricao,
                registros: `${regRondas} | ${regOcorrencias}`,
            };
            rondas.push(rondaAux);
        }
        return rondas;
    }

    function tableMiddleClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"));
        const reg: any = dados[idx];
        setShowModalRonda(true);
        setRondaRegistro(reg);
        // const link = `/qrcode/editar?id=${reg.id_qrcode}`
        // if (event.button === 1) {
        //     window.open(link)
        // }
    }

    function tableClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"));
        const reg: any = dados[idx];
        setShowModalRonda(true);
        setRondaRegistro(reg);
        // const link = `/qrcode/editar?id=${reg.id_qrcode}`
        // if (event.button === 0) {
        //     window.location.assign(link)
        // }
    }

    return (
        <div id="main">
            <LoadingModal show={loading} handleClose={() => setLoading(false)} />
            {showModalRonda && <RondaRegistroModal show={showModalRonda} rondaRegistro={rondaRegistro} handleClose={() => setShowModalRonda(false)} />}

            <div className="div-row-space-between">
                <h1 id="titleMain">Rondas Registros</h1>
            </div>
            <br />
            <div className="div-row">
                <Form.Control name="data_inicial" type="date" id="data_inicial" placeholder="Data Inicial" style={inputDatas} />
                <Form.Control name="data_final" type="date" id="data_final" placeholder="Data Final" style={inputDatas} />
                <Select name="ids_rondas" id="ids_rondas" options={rondasOptions} value={rondasSelection} placeholder="Rondas" isMulti closeMenuOnSelect={false} onChange={(choice: any) => setRondasSelection(choice || [])} styles={styleSelectLarge} />
                <Select name="ids_status" id="ids_status" options={rondasStatusOptions} value={rondasStatusSelection} placeholder="Status" isMulti closeMenuOnSelect={false} onChange={(choice: any) => setRondasStatusSelection(choice || [])} styles={styleSelectSmall} />
                <Select name="ids_qrcodes" id="ids_qrcodes" options={qrcodesOptions} value={qrcodesSelection} placeholder="QrCodes" isMulti closeMenuOnSelect={false} onChange={(choice: any) => setQrcodesSelection(choice || [])} styles={styleSelectLarge} />
                <Select name="ids_colaboradores" id="ids_colaboradores" options={colaboradoresOptions} value={colaboradoresSelection} placeholder="Colaboradores" isMulti closeMenuOnSelect={false} onChange={(choice: any) => setColaboradoresSelection(choice || [])} styles={styleSelectLarge} />
                <Button variant="primary" onClick={() => carregarRondas()} style={{ height: "40px" }} className="div-row-space-between">
                    Filtrar <span className="material-symbols-outlined">filter_alt</span>
                </Button>
            </div>
            <br></br>
            <DataTable dados={dadosFormatados} tableSize={"auto"} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} defaultRows={23} />
        </div>
    );
}

interface iRondasRegistrosView {
    id_ronda_registro: string;
    data_inicio: string;
    data_fim: string;
    matricula: number;
    nome_completo: string;
    ronda_nome: string;
    ronda_status: string;
    registros: string;
}

const columnHelper = createColumnHelper<iRondasRegistrosView>();

const defaultColumns = [
    columnHelper.accessor((row) => `${dayjs(row.data_inicio).format("DD/MM/YYYY HH:mm:ss")}`, {
        header: "Data Início",
        size: 50,
    }),
    columnHelper.accessor((row) => `${row.data_fim !== null ? dayjs(row.data_fim).format("DD/MM/YYYY HH:mm:ss") : "-"}`, {
        header: "Data Fim",
        size: 50,
    }),
    columnHelper.accessor((row) => `#${row.matricula} | ${row.nome_completo}`, {
        header: "Colaborador",
        size: 150,
    }),
    columnHelper.accessor((row) => row.ronda_status, {
        header: "Status",
        size: 20,
    }),
    columnHelper.accessor((row) => row.ronda_nome, {
        header: "Ronda Realizada",
        size: 120,
    }),
    columnHelper.accessor((row) => row.registros, {
        header: "Registros",
        size: 80,
    }),
    columnHelper.accessor((row) => row.id_ronda_registro, {
        header: "#ID",
        size: 150,
    }),
];

const defaultOrder: any[] = [];

const styleSelectLarge = {
    control: (baseStyles: any) => ({
        ...baseStyles,
        width: "20vw",
        borderColor: "#dee2e6",
        minHeight: "39px",
        marginRight: "5px",
        fontSize: "14px",
    }),
};
const styleSelectSmall = {
    control: (baseStyles: any) => ({
        ...baseStyles,
        width: "10vw",
        borderColor: "#dee2e6",
        minHeight: "39px",
        marginRight: "5px",
        fontSize: "14px",
    }),
};

const inputDatas: React.CSSProperties = {
    height: "41px",
    marginRight: "5px",
    maxWidth: "max-content",
};
